var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalyzeSelect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bg-application") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web\\u63A7\\u5236\\u53F0\\u65B0\\u589E\\u5206\\u6790\\u6A21\\u5757",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-41.000000, -73.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(21.000000, 62.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg-application",
    transform: "translate(20.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,1 C19.1045695,1 20,1.8954305 20,3 L20,17 C20,18.1045695 19.1045695,19 18,19 L2,19 C0.8954305,19 6.76353751e-17,18.1045695 0,17 L0,3 C-1.3527075e-16,1.8954305 0.8954305,1 2,1 L18,1 Z M15.4692005,6.71001305 C15.0777592,6.45088078 14.5503651,6.55813845 14.2912328,6.94957976 L12.054,10.3277802 L7.83034692,7.74246654 C7.42162938,7.49224187 6.8869671,7.62918637 6.64886494,8.04508273 L4.26233517,12.2136675 C4.02909662,12.6210685 4.1702832,13.1404095 4.57768424,13.3736481 L4.68163623,13.4242198 C5.06965528,13.5815068 5.52386282,13.43175 5.73766483,13.058299 L7.689,9.64878023 L11.8664716,12.2067496 C12.2568533,12.4457487 12.7663877,12.3326949 13.0190559,11.9510181 L15.7087672,7.8879807 C15.9678994,7.4965394 15.8606418,6.96914532 15.4692005,6.71001305 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzeSelect);
export default __webpack_public_path__ + "static/media/analyze_select.5811709ba191add82ff6717515914e59.svg";
export { ForwardRef as ReactComponent };